
export const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';
export const baseURL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';


export const Username = 'cb589ea3-9b05-44f8-b7c2-de71d128cb0b';
export const Password = '469efb6fc6d285934e1f';
export const baseURLdyte = 'https://api.dyte.io/v2';
export const baseURLdyteMeeting = 'https://app.dyte.io/v2';

export const logoImage = "https://ja.edu.sg/wp-content/uploads/2022/10/logo-new01-1.png"
// export const logoImage ="https://lider-impulz.vercel.app/static/media/logo1.775c2acf99492d8c08fd.png"


export const buttonBackgroundColor = "#2F58A0";

export const validateIdentityNumber = (type, value) => {
    const regexMap = {
        NRIC: /^[ST]\d{7}[A-Z]$/,
        FIN: /^[FGM]\d{7}[A-Z]$/
    };
    return regexMap[type]?.test(value);
};



export const validateIdentityNumbers = (type, value) => {
  if (!value || typeof value !== 'string') return false;

  const upperValue = value.toUpperCase();

  if (type === 'NRIC') {
    // NRIC format: S or T prefix, 7 digits, 1 check letter
    const nricRegex = /^[ST]\d{7}[A-Z]$/;
    return nricRegex.test(upperValue);
  }

  if (type === 'FIN') {
    // FIN format: F, G, or M prefix, 7 digits, 1 check letter
    const finRegex = /^[FGM]\d{7}[A-Z]$/;
    return finRegex.test(upperValue);
  }

  // If unknown type
  return false;
};

const now = new Date();
export const timestamp = now.toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);
